var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTinNhan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 28.5714C0.333496 12.7919 13.1254 0 28.9049 0H71.7621C87.5416 0 100.333 12.7919 100.333 28.5714V71.4286C100.333 87.2081 87.5416 100 71.7621 100H28.9049C13.1254 100 0.333496 87.2081 0.333496 71.4286V28.5714Z",
    fill: "url(#paint0_linear_449_830)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3514 46.7591V57.4734C66.3514 58.1698 66.3246 58.8394 66.2443 59.4823C65.6282 66.7144 61.3693 70.3037 53.5211 70.3037H52.4497C51.78 70.3037 51.1371 70.6251 50.7353 71.1608L47.5211 75.4466C46.1015 77.3484 43.7978 77.3484 42.3782 75.4466L39.1639 71.1608C38.8157 70.7055 38.0389 70.3037 37.4496 70.3037H36.3782C27.8336 70.3037 23.5479 68.1877 23.5479 57.4734V46.7591C23.5479 38.9109 27.1639 34.6519 34.3693 34.0359C35.0122 33.9555 35.6818 33.9287 36.3782 33.9287H53.5211C62.0657 33.9287 66.3514 38.2144 66.3514 46.7591Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0636 36.0447V46.759C77.0636 54.634 73.4475 58.8662 66.2422 59.4822C66.3225 58.8394 66.3493 58.1697 66.3493 57.4733V46.759C66.3493 38.2144 62.0636 33.9286 53.519 33.9286H36.3761C35.6797 33.9286 35.01 33.9554 34.3672 34.0358C34.9833 26.8304 39.2422 23.2144 47.0904 23.2144H64.2332C72.7779 23.2144 77.0636 27.5001 77.0636 36.0447Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3394 53.3483H54.3635",
    stroke: "white",
    strokeWidth: 5.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9644 53.3483H44.9885",
    stroke: "white",
    strokeWidth: 5.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5894 53.3483H35.6135",
    stroke: "white",
    strokeWidth: 5.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_830",
    x1: 0.333496,
    y1: 50,
    x2: 100.333,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB9064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E502A"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTinNhan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TinNhan.48ec98a5.svg";
export { ForwardRef as ReactComponent };